/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/

const VERSION = process.env.REACT_APP_VERSION || '3.0.0';
const semverRegExp = /(?<major>0|[1-9]\d*)\.(?<minor>0|[1-9]\d*)\.*(?<patch>0|[1-9]\d*)*/i;
const versionObject = VERSION.match(semverRegExp);
const versionLink = `${versionObject.groups.major}.${versionObject.groups.minor}`;

export const getHelpURL = (context) => {
	return `https://docs.cedalo.com/streamsheets/${versionLink}/${context}`;
};

export const replaceHelpURL = (url) => {
	return url.replaceAll('$HelpLink$/', getHelpURL(''));
};
